import { render, staticRenderFns } from "./courses.vue?vue&type=template&id=61fbdd7c&scoped=true"
import script from "./courses.vue?vue&type=script&lang=js"
export * from "./courses.vue?vue&type=script&lang=js"
import style0 from "./courses.vue?vue&type=style&index=0&id=61fbdd7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fbdd7c",
  null
  
)

export default component.exports